import React, { Fragment } from 'react'
import { connect } from 'react-redux'
import { Route, Redirect } from 'react-router-dom'
import { withAlert } from 'react-alert'

import TopNavBar from '../components/TopNavBar'

import HomeContainer from './home/HomeContainer'
import InstructionsContainer from './instructions/InstructionsContainer'
import LoginContainer from './login/LoginContainer'
import ChartsContainer from './charts/ChartsContainer'
import ChartFormContainer from './charts/components/ChartFormContainer'
import ChartsListContainer from './charts/components/ChartsListContainer'
import TabulatedChartsListContainer from './charts/components/TabulatedChartsListContainer'
import NotificationsContainer from './notifications/NotificationsContainer'
import UserSettingsContainer from './settings/UserSettingsContainer'
import RequestPasswordReset from './login/components/RequestPasswordReset'
import PasswordReset from './login/components/PasswordReset'
import StatisticsContainer from './statistics/StatisticsContainer'
import AdverseEventsContainer from './adverse-events/AdverseEventsContainer'
import AdverseEventShowPage from './adverse-events/components/AdverseEventShowPage'

import { 
  userIsStudyCoordinator,
  userIsInvestigator,
  userIsPortalAdmin,
  userIsPharmaVigilance,
  userCanSeeAllRoutes,
  userIsSuperUser,
  userIsDataManager,
  userCanOnlyViewReadOnlyCharts,
} from '../functions/userPermissions'


const RouteContainer = (props) => {
  const { currentUser } = props

  const userCanOnlySeeChartsRoute = userIsStudyCoordinator(currentUser) || userIsInvestigator(currentUser) || userCanOnlyViewReadOnlyCharts(currentUser)

  return (
    <Fragment>
      <TopNavBar />

      <center>
        <br/>
        <h4 style={{color: '#cf1a28', marginTop: "50px", width: "100%", position: "sticky"}}>
          {/*
            BEFORE REMOVING MAKE SURE THAT THE STYLING ABOVE IS KEPT
            SINCE UPON REMOVING IT THE FIXED PROPERTIES OF THE TOPNAV
            WILL MAKE CONTENT FROM THE TOP OF THE PAGE INVISIBLE

            EITHER REFACTOR THE CODE OR SIMPLY JUST REMOVE THE TEXT BELOW
          */}
          {/* For demonstration purposes only. Does not necessarily reflect the finalized product. */}
        </h4>
      </center>


      <Route exact path="/login" render={(routerProps) => {
        document.title = 'PROVE Data Entry Portal - Login'
        return <LoginContainer routerProps={routerProps} />
      }} />


      <Route exact path="/home" render={(routerProps) => {
        if (userIsPharmaVigilance(currentUser)) {
          return <Redirect to="/adverse-drug-reactions" />
        } else if (userCanOnlySeeChartsRoute) {
          return <Redirect to="/charts" />
        } else {
          document.title = 'PROVE Data Entry Portal'
          return <HomeContainer routerProps={routerProps} />
        }
      }} />


      <Route exact path="/instructions" render={(routerProps) => {
        document.title = 'PROVE Data Entry Portal - Instructions'
        return <InstructionsContainer routerProps={routerProps} />
      }} />


      <Route exact path="/charts" render={(routerProps) => {
        if (userIsPharmaVigilance(currentUser)) {
          return <Redirect to="/adverse-drug-reactions" />
        } else {
          document.title = 'PROVE Data Entry Portal - Charts'
          return <ChartsContainer routerProps={routerProps} alert={props.alert} />
        }
      }} />


      <Route exact path="/charts/new" render={(routerProps) => {
        if (userIsPharmaVigilance(currentUser)) {
          return <Redirect to="/adverse-drug-reactions" />
        } else if (userIsPortalAdmin(currentUser) || currentUser?.sites?.length === 0) {
          return <Redirect to="/charts" />
        } else {
          document.title = 'PROVE Data Entry Portal - New Patient Chart'
          return <ChartFormContainer routerProps={routerProps} alert={props.alert} />
        }
      }} />


      <Route exact path="/charts/review" render={(routerProps) => {
        if (userIsPharmaVigilance(currentUser)) {
          return <Redirect to="/adverse-drug-reactions" />
        } else if (currentUser && !userIsInvestigator(currentUser) && !userCanSeeAllRoutes(currentUser)) {
          return <Redirect to="/charts" />
        } else {
          document.title = 'PROVE Data Entry Portal - Review Charts'
          return <ChartsListContainer routerProps={routerProps} title="Review Charts" type="review" alert={props.alert} />
        }
      }} />


      <Route exact path="/charts/review/:id" render={(routerProps) => {
        if (userIsPharmaVigilance(currentUser)) {
          return <Redirect to="/adverse-drug-reactions" />
        } else if (currentUser && !userIsInvestigator(currentUser) && !userCanSeeAllRoutes(currentUser)) {
          return <Redirect to="/charts" />
        } else {
          document.title = 'PROVE Data Entry Portal - Review Chart'
          return (
            <ChartFormContainer
              routerProps={routerProps}
              chartForReview
              alert={props.alert}
            />
          )
        }
      }} />


      <Route exact path="/charts/revise" render={(routerProps) => {
        if (userIsPharmaVigilance(currentUser)) {
          return <Redirect to="/adverse-drug-reactions" />
        } else if (userIsPortalAdmin(currentUser)) {
          return <Redirect to="/charts" />
        } else {
          document.title = 'PROVE Data Entry Portal - Charts Needing Revision'
          return (
            <ChartsListContainer
              routerProps={routerProps}
              type="revise"
              title="Charts Needing Revision"
              alert={props.alert}
            />
          )
        }
      }} />


      <Route exact path="/charts/revise/:id" render={(routerProps) => {
        if (userIsPharmaVigilance(currentUser)) {
          return <Redirect to="/adverse-drug-reactions" />
        } else if (userIsPortalAdmin(currentUser)) {
          return <Redirect to="/charts" />
        } else {
          document.title = 'PROVE Data Entry Portal - Revise Chart'
          return (
            <ChartFormContainer
              routerProps={routerProps}
              chartForRevision
              alert={props.alert}
            />
          )
        }
      }} />

      <Route exact path="/charts/validate" render={(routerProps) => {
        if (userIsPharmaVigilance(currentUser)) {
          return <Redirect to="/adverse-drug-reactions" />
        } else if (!currentUser || userIsDataManager(currentUser)) {
          document.title = 'PROVE Data Entry Portal - Validate Approved Charts'
          return (
            <TabulatedChartsListContainer
              routerProps={routerProps}
              title="Validate Approved Charts"
              chartForRevision
              alert={props.alert}
              route="validate"
            />
          )
        } else {
          return <Redirect to="/charts" />
        }
      }} />

      <Route exact path="/charts/validate/:id" render={(routerProps) => {
        if (userIsPharmaVigilance(currentUser)) {
          return <Redirect to="/adverse-drug-reactions" />
        } else if (!currentUser || userIsDataManager(currentUser)) {
          document.title = 'PROVE Data Entry Portal - Validate Chart'
          return (
            <ChartFormContainer
              routerProps={routerProps}
              chartForReview
              alert={props.alert}
            />
          )
        } else {
          return <Redirect to="/charts" />
        }
      }} />


      <Route exact path="/charts/review-data-manager-notes" render={(routerProps) => {
        if (userIsPharmaVigilance(currentUser)) {
          return <Redirect to="/adverse-drug-reactions" />
        } else if (currentUser && (userIsPortalAdmin(currentUser) || currentUser.can_view_incomplete_charts)) {
          return <Redirect to="/charts/view-data-manager-notes" />  
        } else if (currentUser && !userIsInvestigator(currentUser) && !userCanSeeAllRoutes(currentUser)) {
          return <Redirect to="/charts" />
        } else {
          document.title = 'PROVE Data Entry Portal - Charts Requiring Data Validation'
          return (
            <ChartsListContainer
              routerProps={routerProps}
              title="Charts Requiring Data Validation"
              alert={props.alert}
            />
          )
        }
      }} />

      <Route exact path="/charts/review-data-manager-notes/:id" render={(routerProps) => {
        if (userIsPharmaVigilance(currentUser)) {
          return <Redirect to="/adverse-drug-reactions" />
        } else if (currentUser && (userIsPortalAdmin(currentUser) || currentUser.can_view_incomplete_charts)) {
          return <Redirect to="/charts/view-data-manager-notes/:id" />  
        } else if (currentUser && !userIsInvestigator(currentUser) && !userCanSeeAllRoutes(currentUser)) {
          return <Redirect to="/charts" />
        } else {
          document.title = 'PROVE Data Entry Portal - Chart Requiring Data Validation'
          return (
            <ChartFormContainer
              routerProps={routerProps}
              chartForReview
              reviewDataManagerNotes
              alert={props.alert}
            />
          )
        }
      }} />


      <Route exact path="/charts/view-data-manager-notes" render={(routerProps) => {
        if (userIsPharmaVigilance(currentUser)) {
          return <Redirect to="/adverse-drug-reactions" />
        } else if (currentUser && userIsInvestigator(currentUser)) {
          return <Redirect to="/charts/review-data-manager-notes" />
        } else if (currentUser && !userIsPortalAdmin(currentUser) && !userCanSeeAllRoutes(currentUser) && !currentUser.can_view_incomplete_charts) {
          return <Redirect to="/charts" />
        } else {
          document.title = 'PROVE Data Entry Portal - Charts With Pending Validation Requests'
          return (
            <ChartsListContainer
              routerProps={routerProps}
              title="Charts With Pending Validation Requests"
              alert={props.alert}
            />
          )
        }
      }} />

      <Route exact path="/charts/view-data-manager-notes/:id" render={(routerProps) => {
        if (userIsPharmaVigilance(currentUser)) {
          return <Redirect to="/adverse-drug-reactions" />
        } else if (currentUser && userIsInvestigator(currentUser)) {
          return <Redirect to="/charts/review-data-manager-notes/:id" />
        } else if (currentUser && !userIsPortalAdmin(currentUser) && !userCanSeeAllRoutes(currentUser) && !currentUser.can_view_incomplete_charts) {
          return <Redirect to="/charts" />
        } else {
          document.title = 'PROVE Data Entry Portal - Chart With Pending Validation Requests'
          return (
            <ChartFormContainer
              routerProps={routerProps}
              notesAreReadOnly
              chartIsReadOnly
              alert={props.alert}
            />
          )
        }
      }} />


      <Route exact path="/charts/all" render={(routerProps) => {
        if (userIsPharmaVigilance(currentUser)) {
          return <Redirect to="/adverse-drug-reactions" />
        } else if (currentUser && !userIsSuperUser(currentUser)) {
          return <Redirect to="/charts/submitted" />
        } else {
          document.title = 'PROVE Data Entry Portal - All Charts'
          return (
            <TabulatedChartsListContainer
              routerProps={routerProps}
              title="Submitted Charts"
              chartApproved
              alert={props.alert}
              route='all'
            />
          )
        }
      }} />


      <Route exact path="/charts/all/:id" render={(routerProps) => {
        if (userIsPharmaVigilance(currentUser)) {
          return <Redirect to="/adverse-drug-reactions" />
        } else if (currentUser && !userIsSuperUser(currentUser)) {
          return <Redirect to="/charts/submitted" />
        } else {
          document.title = 'PROVE Data Entry Portal - All Chart'
          return (
            <ChartFormContainer
              routerProps={routerProps}
              chartApproved
              alert={props.alert}
            />
          )
        }
      }} />


      <Route exact path="/charts/submitted" render={(routerProps) => {
        if (userIsPharmaVigilance(currentUser)) {
          return <Redirect to="/adverse-drug-reactions" />
        } else if (currentUser && userIsSuperUser(currentUser)) {
          return <Redirect to="/charts/all" />
        } else {
          document.title = 'PROVE Data Entry Portal - Submitted Charts'
          return (
            <TabulatedChartsListContainer
              routerProps={routerProps}
              title="Submitted Charts"
              chartApproved
              alert={props.alert}
              route='submitted'
            />
          )
        }
      }} />


      <Route exact path="/charts/submitted/:id" render={(routerProps) => {
        if (userIsPharmaVigilance(currentUser)) {
          return <Redirect to="/adverse-drug-reactions" />
        } else if (currentUser && userIsSuperUser(currentUser)) {
          const chartId = routerProps?.match?.params?.id || ''
          return <Redirect to={`/charts/all/${chartId}`} />
        } else {
          document.title = 'PROVE Data Entry Portal - Submitted Chart'
          return (
            <ChartFormContainer
              routerProps={routerProps}
              chartApproved
              alert={props.alert}
            />
          )
        }
      }} />


      <Route exact path="/notifications" render={(routerProps) => {
        document.title = 'PROVE Data Entry Portal - Notifications'
        return <NotificationsContainer routerProps={routerProps} alert={props.alert} />
      }} />


      <Route exact path="/settings" render={(routerProps) => {
        document.title = 'PROVE Data Entry Portal - User Settings'
        return <UserSettingsContainer routerProps={routerProps} alert={props.alert} />
      }} />


      <Route exact path="/statistics" render={(routerProps) => {
        if (currentUser && !userIsPortalAdmin(currentUser) && !userCanSeeAllRoutes(currentUser) && !currentUser.can_view_statistics) {
          return <Redirect to="/home" />
        } else {
          document.title = 'PROVE Data Entry Portal - Statistics'
          return <StatisticsContainer routerProps={routerProps} alert={props.alert} />
        }
      }} />


      <Route exact path="/adverse-drug-reactions" render={(routerProps) => {
        if (currentUser && !userIsPharmaVigilance(currentUser) && !userIsPortalAdmin(currentUser) && !userCanSeeAllRoutes(currentUser)) {
          return <Redirect to="/home" />
        } else {
          document.title = 'PROVE Data Entry Portal - Adverse Drug Reactions'
          return <AdverseEventsContainer routerProps={routerProps} alert={props.alert} />
        }
      }} />


      <Route exact path="/adverse-drug-reactions/:id" render={(routerProps) => {
        if (currentUser && !userIsPharmaVigilance(currentUser) && !userIsPortalAdmin(currentUser) && !userCanSeeAllRoutes(currentUser)) {
          return <Redirect to="/home" />
        } else {
          document.title = 'PROVE Data Entry Portal - Adverse Drug Reaction'
          return <AdverseEventShowPage routerProps={routerProps} alert={props.alert} />
        }
      }} />


      <Route exact path="/reset-password" render={(routerProps) => {
        document.title = 'PROVE Data Entry Portal - Request Password Reset'
        return <RequestPasswordReset routerProps={routerProps} alert={props.alert} />
      }} />



      <Route exact path="/reset-password/:token_id/:token" render={(routerProps) => {
        document.title = 'PROVE Data Entry Portal - Reset Password'
        return <PasswordReset routerProps={routerProps} alert={props.alert} />
      }} />


      <Route exact path="/" render={(routerProps) => {
        document.title = 'PROVE Data Entry Portal'
        return <Redirect to="/home" />
      }} />

      {/* <Route path="*" render={(routerProps) => {
        document.title = 'PROVE Data Entry Portal'
        return <Redirect to="/home" />
      }} />

      <Route path="/charts/*" render={(routerProps) => {
        document.title = 'PROVE Data Entry Portal'
        return <Redirect to="/charts" />
      }} /> */}


      {/* <Route path="/charts/*">
        <Redirect to="/home" />
      </Route>

      <Route path="/charts/*">
        <Redirect to="/home" />
      </Route> */}
    </Fragment>
  )
}

const mapStateToProps = (state) => {
  return {
    currentUser: state.loginReducer.currentUser,
  }
}

const ConnectedRouteContainer = connect(mapStateToProps)(RouteContainer)

export default withAlert()(ConnectedRouteContainer)
